@if (isLoader) {
  <bmcore-loader></bmcore-loader>
}

<form [formGroup]="updatePasswordForm" (ngSubmit)="onSubmit()">
  <div class="update-password-form">
    <bmcore-input
      formControlName="currentPassword"
      [title]="'Current password'"
      [type]="'password'"
      [className]="'edit-profile'"
      [controlFormName]="'currentPassword'"
    >
    </bmcore-input>
    <bmcore-input
      formControlName="newPassword"
      [title]="'New password'"
      [type]="'password'"
      [className]="'edit-profile'"
      [controlFormName]="'newPassword'"
    >
    </bmcore-input>
    <bmcore-input
      formControlName="confirmPassword"
      [title]="'Confirm password'"
      [type]="'password'"
      [className]="'edit-profile'"
      [controlFormName]="'confirmPassword'"
    >
    </bmcore-input>
  </div>

  <div class="update-password-form__btn">
    <bmcore-button title="Save" styleName="right" [disabled]="isLoader"> </bmcore-button>
  </div>
</form>
